import { createAsyncThunk } from '@reduxjs/toolkit'
import { userStoreManagementAPI } from '@services/api'

export const fetchUserStoreManagementList = createAsyncThunk(
  'userStoreManagement/fetchUserStoreManagementList',
  async (params: TUserStoreManagementAPI.Params.list, { rejectWithValue }) => {
    try {
      const response = await userStoreManagementAPI.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const searchUserStoreManagementList = createAsyncThunk(
  'userStoreManagement/searchUserStoreManagementList',
  async (params: TUserStoreManagementAPI.Params.Search, { rejectWithValue }) => {
    try {
      const response = await userStoreManagementAPI.searchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
export const fetchUserStoreManagementDetail = createAsyncThunk(
  'userStoreManagement/fetchUserStoreManagementDetail',
  async (params: TUserStoreManagementAPI.Params.Detail, { rejectWithValue }) => {
    try {
      const response = await userStoreManagementAPI.fetchSingle(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const sendCredentialGenRequest = createAsyncThunk(
  'userStoreManagement/sendCredentialGenRequest',
  async (data: TUserStoreManagementAPI.Params.SendCredentialGen, { rejectWithValue }) => {
    try {
      const response = await userStoreManagementAPI.sendCredentialGenRequest(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
